import React from "react";
import PropTypes from "prop-types";
import RatingEmoji from "../RatingEmoji";
import {
  Wrapper,
  Rating,
  Input,
  Label,
  Title,
  StepCount,
} from "../styles/rating-steps-styles";

const Step3 = ({ setRating, rating }) => (
  <Wrapper noPointerEvents={rating}>
    <RatingEmoji rating={rating} />
    <Title className="animated delay fadeInDown">Speed of Response</Title>
    <Rating className="rating animated delay fadeInDown">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step3Rating"
        id="rating-35"
        value={5}
      />
      <Label htmlFor="rating-35" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step3Rating"
        id="rating-34"
        value={4}
      />
      <Label htmlFor="rating-34" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step3Rating"
        id="rating-33"
        value={3}
      />
      <Label htmlFor="rating-33" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step3Rating"
        id="rating-32"
        value={2}
      />
      <Label htmlFor="rating-32" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step3Rating"
        id="rating-31"
        value={1}
      />
      <Label htmlFor="rating-31" />
    </Rating>
    <StepCount>step 3 of 5</StepCount>
  </Wrapper>
);

Step3.propTypes = {
  setRating: PropTypes.func.isRequired,
  rating: PropTypes.number,
};

Step3.defaultProps = {
  rating: PropTypes.isNull,
};

export default Step3;
